import { useContext } from "react";
import { GlobalContext, GlobalContextType } from "./GlobalContextProvider";

export function useConsumerTypeContext() {
  const { consumerTypes } = useContext<GlobalContextType>(GlobalContext);
  return consumerTypes;
}
